import { ListPagination } from "Common/ListPagination";
import TableContainer from "Common/TableContainer";
import TableEntry from "Common/TableEntry";
import moment from "moment";
import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Button, Modal } from "react-bootstrap";

interface Props {
  matchedRollBack: matchRollBackRes[];
  getOddsRollBack: (market_id: string,password:string) => Promise<void>;
  getOddsABD: (market_id: string, rollback: number,password:string) => Promise<void>;
  setRollback: Dispatch<SetStateAction<boolean>>;
  showRollback: boolean;
  setLimit: any;
  setPageNo: any;
  totalPage: number;
  limit: number;
  pageNo: number;
  setAbdFancy: Dispatch<any>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

const ResultRollbackTable: FC<Props> = ({
  setLimit,
  setPageNo,
  matchedRollBack,
  totalPage,
  limit,
  pageNo,
  getOddsRollBack,
  getOddsABD,
  setRollback,
  showRollback,
  setAbdFancy,
  setIsLoading,
}) => {
  const [marketId, setMarketId] = useState<string>("");
  const [matchedName, setMatchedName] = useState<string>("");
  const [marketName, setMarketName] = useState<string>("");
  const [rollBack, setRollbackData] = useState<number>(0);
  const [password, setPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");

  const toggleRollback = (
    id: string,
    matchName: string,
    marketName: string,
    rollback: number
  ) => {
    setRollback(!showRollback);
    setMarketId(id);
    setMatchedName(matchName);
    setMarketName(marketName);
    setRollbackData(rollback);
    setAbdFancy(!rollback);
  };

  const handleUpdate = () => {
    if (!password.trim()) {
      setPasswordError("Password is required");
      return;
    }

    setIsLoading(true);
    setPasswordError("");

    if (rollBack === 0) {
      getOddsRollBack(marketId,password);
    } else {
      getOddsABD(marketId, rollBack,password);
    }

    setPassword("");
  };

  const columns = useMemo(
    () => [
      {
        header: "No.",
        accessorKey: "no",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (pageNo - 1) * limit + cell?.row?.index + 1;
        },
      },
      {
        header: "Sport Name",
        accessorKey: "sport_name",
        enableColumnFilter: false,
      },
      {
        header: "Series Name",
        accessorKey: "series_name",
        enableColumnFilter: false,
      },
      {
        header: "Match Name",
        accessorKey: "match_name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div>
              <p className="mb-0">{cell.row?.original?.match_name}</p>
              <p
                className={`mb-0 ${
                  !cell.row?.original?.is_abandoned
                    ? "text-success"
                    : "text-danger"
                }`}
              >
                {cell.row?.original?.result_status}
              </p>
            </div>
          );
        },
      },
      {
        header: "Market Name",
        accessorKey: "market_name",
        enableColumnFilter: false,
      },
      {
        header: "Winner Name",
        accessorKey: "result_value_selections",
        enableColumnFilter: false,
      },
      {
        header: "Date",
        accessorKey: "date",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div>
              <p className="mb-0">
                {moment(cell.row.original?.match_date).format(
                  "DD-MM-YYYY hh:mm:ss:SSS A"
                )}
              </p>
            </div>
          );
        },
      },
      {
        header: "Settled Time",
        accessorKey: "settledTime",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div>
              <p className="mb-0">
                {moment(cell.row.original?.result_settled_at).format(
                  "DD-MM-YYYY hh:mm:ss:SSS A"
                )}
              </p>
            </div>
          );
        },
      },
      {
        header: "Result",
        accessorKey: "result",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div>
              <p className="mb-0">
                {!cell.row?.original?.is_abandoned ? "1" : "Abandoned"}
              </p>
            </div>
          );
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const is_rollback = cell?.row?.original?.button;
          const isResult =
            cell?.row?.original?.status?.toLowerCase() !== "abandoned";
          return (
            is_rollback == "Roll Back" && (
              <Button
                className="btn-sm"
                variant="info"
                onClick={() =>
                  toggleRollback(
                    cell.row?.original?.market_id,
                    cell.row?.original?.match_name,
                    cell.row?.original?.market_name,
                    cell.row?.original?.is_abandoned
                  )
                }
              >
                {isResult ? "Roll Back" : "Abandoned"}
              </Button>
            )
          );
        },
      },
    ],
    [pageNo, limit]
  );

  useEffect(() => {
    setIsLoading(true);
  }, [pageNo, limit]);

  const handleModalClose = () => {
    setRollback(false);
    setPassword("");
    setPasswordError("");
  };

  return (
    <>
      <TableContainer
        columns={columns || []}
        data={matchedRollBack || []}
        isBordered={false}
        customPageSize={limit}
        isPagination={false}
        tableClass="table-centered align-middle table-nowrap table-striped mb-3"
        theadClass="text-muted table-light"
        SearchPlaceholder="Search Products..."
        setLimit={setLimit}
        setPageNo={setPageNo}
      />

      <nav
        aria-label="Page navigation"
        className="px-3 d-flex flex-column flex-sm-row align-items-center"
      >
        <TableEntry
          limit={limit}
          handlelimitFilter={(value: number) => setLimit(value)}
        />
        <ListPagination
          listTotal={{ total: totalPage / limit, page: pageNo }}
          handlePageFilter={(value: number) => setPageNo(value)}
        />
      </nav>

      <Modal show={showRollback} onHide={handleModalClose} className="zoomIn" scrollable>
        <Modal.Header className="modal-title fw-bold d-flex justify-content-between">
          <div className="d-flex align-items-center">Roll Back</div>
          <Button variant="light btn-sm" onClick={handleModalClose}>
            <i className="ri-close-line fs-xl align-middle"></i>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <h4>
            Are you sure you want to {rollBack === 0 ? "Rollback" : "Abandoned"} result?
          </h4>
          <p>
            {matchedName} - {marketName}
          </p>

          <div className="mt-3">
            <label htmlFor="rollback-password" className="form-label">
              Enter Password
            </label>
            <input
              id="rollback-password"
              type="password"
              className={`form-control ${passwordError ? "is-invalid" : ""}`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password to confirm"
            />
            {passwordError && (
              <div className="invalid-feedback">{passwordError}</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top">
          <Button onClick={handleUpdate}>Update</Button>
          <Button variant="subtle-dark" onClick={handleModalClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResultRollbackTable;
